// import fs from 'fs';

export default function (Site, $) {
  Site.widget("resources-search", {
    _create() {
      // this.element.find(".tags label").click((e) => {
      //     console.log('clicked');
      //     this.element.find(".tags label").removeClass("checked");
      //     this.element.find(".tags label input").attr('checked', false);

      //     $(e.target).attr('checked', 'checked').parent('label').addClass("checked");

      // });

      this.element.find("#strat-search").keypress((e) => {
        if (e.which == 13) {
          $(e.target).attr("name", "search");
        }
      });

      this.element.find(".filter-menu form").change((e) => {
        this.element
          .find(".filter-menu form")
          .attr("action", this.element.find(".select-type").val())
          .submit();
      });

      this.element.find("#strat-search").keyup((e) => {
        // this.element.toggleClass("collapsed")
        console.log(e.target.value);

        this.element.find(".box").map((x) => {
          // this.element.hide();
          // console.log($(this.element.find(".box").get(x)).html());

          if (
            e.target.value == "" ||
            $(this.element.find(".box").get(x)).html().includes(e.target.value)
            // &&
            // $(this.element.find(".box").get(x)).data('focus-area').includes($('input[name=focus-area]:checked').val())
          ) {
            $(this.element.find(".box").get(x)).show();
          } else {
            $(this.element.find(".box").get(x)).hide();
          }
        });
      });
    },
  });
}
